import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["prices"]

    seriesChanged(event) {
        const seriesId = event.target.value
        if (!seriesId) return

        // Fetch variant names via Turbo Stream/Mini-endpoint (JSON is fine too)
        fetch(`/product_series/${seriesId}/variant_names`)
            .then(r => r.json())
            .then(names => this.renderPriceInputs(names))
    }

    renderPriceInputs(names) {
        this.pricesTarget.innerHTML = names.map(name => `
    <div class="relative">
      <label class="block text-sm font-medium text-gray-700 mb-1">${name}</label>
      <div class="relative">
        <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500 text-sm">₱</span>
        <input type="number" step="0.01"
               name="product[prices][${name}]"
               class="pl-7 pr-3 py-2 block w-full rounded-md border border-gray-300 shadow-sm
                      focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"/>
      </div>
    </div>
  `).join("")
    }
}